document.addEventListener('DOMContentLoaded', function() {
  const FEED_URL = 'https://www.ashridgetrees.co.uk/blogs/feed.json';
  const grid = document.getElementById('blog-posts-grid');
  if (!grid) return;

  function formatDate(dateStr) {
    try {
      return new Date(dateStr).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
    } catch(e) { return ''; }
  }

  function stripHtml(html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  function fixDomain(url) {
    return url
      .replace('https://blogs.ashridgetrees.co.uk', 'https://www.ashridgetrees.co.uk')
      .replace('https://ashridgetreesblog.kinsta.cloud', 'https://www.ashridgetrees.co.uk');
  }

  function getFirstImage(htmlString) {
    try {
      const matches = [...htmlString.matchAll(/<img[^>]+src=["']([^"']+)["']/gi)];
      for (const match of matches) {
        const src = match[1];
        if (src.includes('cdn.shopify.com')) continue;
        if (src.includes('cdn.shop')) continue;
        return fixDomain(src);
      }
      return '';
    } catch(e) { return ''; }
  }

  fetch(FEED_URL)
    .then(res => res.text())
    .then(str => {
      const parser = new DOMParser();
      const xml = parser.parseFromString(str, 'text/xml');
      const items = Array.from(xml.querySelectorAll('item')).slice(0, 3);

      if (!items.length) {
        grid.innerHTML = '<p>No posts found.</p>';
        return;
      }

      grid.innerHTML = '';

      items.forEach(item => {
        const title = item.querySelector('title').textContent || '';

        let link = '';
        try {
          const linkEl = item.querySelector('link');
          if (linkEl && linkEl.nextSibling && linkEl.nextSibling.nodeValue && linkEl.nextSibling.nodeValue.trim().startsWith('http')) {
            link = linkEl.nextSibling.nodeValue.trim();
          }
          if (!link && linkEl && linkEl.textContent && linkEl.textContent.trim().startsWith('http')) {
            link = linkEl.textContent.trim();
          }
          if (!link) {
            const guid = item.querySelector('guid');
            if (guid && guid.textContent.trim().startsWith('http')) {
              link = guid.textContent.trim();
            }
          }
        } catch(e) {}

        link = (link || '#').replace('https://blogs.ashridgetrees.co.uk', 'https://www.ashridgetrees.co.uk');

        const pubDate = item.querySelector('pubDate') ? item.querySelector('pubDate').textContent : '';
        const description = item.querySelector('description') ? item.querySelector('description').textContent : '';
        const encoded = item.getElementsByTagNameNS('http://purl.org/rss/1.0/modules/content/', 'encoded')[0];
        const contentHtml = encoded ? encoded.textContent : '';

        const image = getFirstImage(description) || getFirstImage(contentHtml);
        const excerpt = stripHtml(description).substring(0, 150).trim() + '...';

        const card = document.createElement('a');
        card.href = link;
        card.className = 'blog-post-card';
        card.target = '_blank';
        card.rel = 'noopener';

        if (image) {
          const img = document.createElement('img');
          img.className = 'blog-post-image';
          img.src = image;
          img.alt = title;
          img.loading = 'lazy';
          card.appendChild(img);
        } else {
          const placeholder = document.createElement('div');
          placeholder.className = 'blog-post-image-placeholder';
          card.appendChild(placeholder);
        }

        const content = document.createElement('div');
        content.className = 'blog-post-content';

        const dateEl = document.createElement('p');
        dateEl.className = 'blog-post-date';
        dateEl.textContent = formatDate(pubDate);
        content.appendChild(dateEl);

        const titleNode = document.createElement('h3');
        titleNode.className = 'blog-post-title';
        titleNode.textContent = title;
        content.appendChild(titleNode);

        const excerptEl = document.createElement('p');
        excerptEl.className = 'blog-post-excerpt';
        excerptEl.textContent = excerpt;
        content.appendChild(excerptEl);

        card.appendChild(content);
        grid.appendChild(card);
      });
    })
    .catch(err => {
      console.error('Feed error:', err);
      grid.innerHTML = '<p>Unable to load blog posts.</p>';
    });
});